/**
 * PLD registration page
 */

/**
 * Selectors
 */
export const RETAILER_ACCOUNT_REGISTRATION_PAGE_ID =
  'retailer-account-registration';
export const RETAILER_ACCOUNT_REGISTRATION_CREATE_BANNER_ID = `${RETAILER_ACCOUNT_REGISTRATION_PAGE_ID}-create-account`;
export const RETAILER_ACCOUNT_REGISTRATION_INVALID_TOKEN_BANNER_ID =
  'retailer-create-account-invalidated-token';

/**
 * Translation keys
 */
export const RETAILER_ACCOUNT_REGISTRATION_TITLE_TRANSLATION_KEY =
  'retailer_account_registration_title';

/**
 * General
 */
export const ACCOUNT_CREATION_REDIRECT_URL = '/cb';

export const RETAIL_PARTNER_VENDOR_CODE_SELECTION =
  'retail-partner-vendor-code-selection';

export const VENDOR_CODE_SELECTION_SUBMIT =
  'retail-partner-vendor-code-selection-submit';

export const GROCERY_CENTRAL_PORTAL = 'GROCERY_CENTRAL';

export const PRE_POPULATION_SUCCESS = 'wfm-pre-population-success';

export const SELLING_ACCOUNTS = 'sellingAccounts';
export const SELECTED_ADDRESS_ID = 'selectedAddressId';
